import "./News.css";
const News = function (props) {
    return (
        
        <React.Fragment>
            <div className="MainContainerMuseumWebPart"> 
                <div className="pictureAreaMuseum">
                   <img className="imgContainer img-fluid" src={props.data.MuseumPromotionImg_Url+"?RenditionID=5"} data-holder-rendered="true"  alt={"תמונת "+ props.data.MODMuseumMainTitle}/>
                </div>
                <div className="titleAndTextArea">
                    <h3 className="mainTitle">{props.data.MODMuseumMainTitle}</h3>
                    <div className="textArea">
                        {/* <div className="museumSummaryText" dangerouslySetInnerHTML={{__html: props.data.ModMuseumMainText}}></div> */}
                        <div className="museumSummaryText" dangerouslySetInnerHTML={{__html: props.data.MODMuseumSummary}}></div>
                        <div className="linkAreaRreadMoreMmuseum">
                            <a className="readMoreBut" href={props.data.FileRef} title={props.data.MODFocusLink_Description}>קרא עוד<i className="fas fa-angle-left" /></a>
                        </div>
                    </div>
                    
                </div>
            </div>
        </React.Fragment>
    );
}
export default News;